import React, { memo } from 'react';
import { Header } from '../components/sales/Header';
import { HeroSection } from '../components/sales/HeroSection';
import { PainPoints } from '../components/sales/PainPoints';
import { WhatYouGet } from '../components/sales/WhatYouGet';
import { WhoIsItFor } from '../components/sales/WhoIsItFor';
import { PricingCTA } from '../components/sales/PricingCTA';
import { FAQSection } from '../components/sales/FAQSection';
import { FlagDivider } from '../components/sales/FlagDivider';
export function SalesPage() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <main className="min-h-screen bg-[#0a0a0a] text-zinc-200 selection:bg-[#FFCC00] selection:text-black" data-id="element-168">
      <Header data-id="element-169" />
      <HeroSection data-id="element-170" />
      <PainPoints data-id="element-171" />
      <WhatYouGet data-id="element-172" />
      <WhoIsItFor data-id="element-173" />
      <PricingCTA data-id="element-174" />
      <FAQSection data-id="element-175" />

      {/* Final Emotional Footer */}
      <footer className="py-12 sm:py-16 lg:py-24 px-4 text-center bg-black border-t border-zinc-900" data-id="element-176">
        <div className="max-w-2xl mx-auto" data-id="element-177">
          <p className="text-lg sm:text-xl lg:text-2xl font-serif text-white mb-6 sm:mb-8 leading-relaxed" data-id="element-178">
            "Porque un país puede perderlo todo… <br data-id="element-179" />
            <span className="text-zinc-400 italic" data-id="element-180">
              pero si conserva la memoria, todavía puede reconstruirse."
            </span>
          </p>

          <button onClick={scrollToPricing} className="bg-[#FFCC00] hover:bg-[#e6b800] text-[#0a0a0a] font-bold py-3 px-6 sm:px-8 rounded-full transition-all transform hover:scale-105 shadow-lg shadow-yellow-900/20 mb-8 sm:mb-12 text-sm sm:text-base" data-id="element-181">
            Comprar Ahora — $14.97
          </button>

          <div className="flex justify-center items-center gap-2 opacity-50 mb-6 sm:mb-8" data-id="element-182">
            <FlagDivider className="w-12 sm:w-16 h-1" data-id="element-183" />
          </div>

          <p className="text-zinc-600 text-xs sm:text-sm" data-id="element-184">
            © {new Date().getFullYear()} Venezuela: La verdad. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </main>;
}